import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=52cf216a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cf216a')) {
      api.createRecord('52cf216a', component.options)
    } else {
      api.reload('52cf216a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=52cf216a&", function () {
      api.rerender('52cf216a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/comp/openstreetmap.vue"
export default component.exports